import type { ReactNode } from 'react';
import { Result } from 'antd';

import { hasCapability, useAuth } from './AuthProvider';

interface RequireCapabilityProps {
  capability: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function RequireCapability({
  capability,
  children,
  fallback,
}: RequireCapabilityProps) {
  const { currentUser } = useAuth();

  if (!hasCapability(currentUser, capability)) {
    return (
      <>
        {fallback ?? (
          <Result status="403" title="403" subTitle="无权访问该功能" />
        )}
      </>
    );
  }

  return <>{children}</>;
}
